import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = ["title", "disabled", "checked", "id", "role"];
const _hoisted_2 = ["for"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormElementDescription = _resolveComponent("FormElementDescription");
    return (_openBlock(), _createElementBlock("span", null, [
        _createElementVNode("div", {
            class: _normalizeClass('form-check' + (_ctx.toggle ? ' form-switch' : ''))
        }, [
            _createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                title: _ctx.text,
                disabled: _ctx.disabled,
                onInput: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                checked: _ctx.modelValue,
                id: _ctx.id,
                role: _ctx.toggle ? 'switch' : ''
            }, null, 40, _hoisted_1),
            (_ctx.text !== '')
                ? (_openBlock(), _createElementBlock("label", {
                    key: 0,
                    for: _ctx.id,
                    class: "form-check-label"
                }, _toDisplayString(_ctx.text), 9, _hoisted_2))
                : _createCommentVNode("", true)
        ], 2),
        _createVNode(_component_FormElementDescription, { description: _ctx.description }, null, 8, ["description"])
    ]));
}
